import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { feedbackApiRef } from './api/FeedbackApi';
import { FeedbackClient } from './api/FeedbackClient';
import { rootRouteRef, viewFeedbackRouteRef } from './routes';

export const feedbackPlugin = createPlugin({
  id: 'feedback',
  apis: [
    createApiFactory({
      api: feedbackApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        identityApi: identityApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, identityApi, fetchApi }) =>
        new FeedbackClient({ discoveryApi, configApi, identityApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
    view: viewFeedbackRouteRef,
  },
});

export const FeedbackPage = feedbackPlugin.provide(
  createRoutableExtension({
    name: 'FeedbackPage',
    component: () =>
      import('./components/FeedbackComponent/FeedbackDialog').then(
        m => m.FeedbackDialog,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ViewFeedbackPage = feedbackPlugin.provide(
  createRoutableExtension({
    name: 'ViewFeedbackPage',
    component: () =>
      import('./components/ViewFeedbackPageComponent').then(
        m => m.ViewFeedbackPage,
      ),
    mountPoint: viewFeedbackRouteRef,
  }),
);
